<template>
  <div>
    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
    >
      <v-form v-model="valid">
        <div :class="containerClasses">
          <v-skeleton-loader
            v-if="$apollo.queries.getWebServiceUser.loading"
            class="mb-2"
            type="text@8"
          />
          <div v-else>
            <EkitabuTextInput
              id="pdq-transaction-id"
              v-model="pdqTransactionId"
              class="mt-3"
              :label="$t('checkout.pdqTransactionId')"
              :placeholder="$t('checkout.pdqTransactionId')"
            />
            <admin-order
              class="mt-3"
              :is-cash-transaction="true"
              @updateAdminOrderDetails="setAdminOrderDetails"
            />
            <delivery-options
              v-if="isPrintOrder"
              @updateShippingInfo="setShippingInfo"
              @updateSchoolInfo="setSchoolInfo"
              @updateIsPickupOrder="setIsPickupOrder"
              @updateIsValid="setDeliveryOptionsValid"
              @updateDeliveryOption="(opt) => $emit('deliveryOptionChanged', opt)"
            />
          </div>
        </div>
        <place-order-button
          :invalid="invalid || !deliveryOptionsValid"
          :shipping-info="shippingInfo"
          :school-info="schoolInfo"
          :is-pickup-order="isPickupOrder"
          :is-admin-order="true"
          :admin-order-details="adminOrderDetails"
          :pdq-transaction-id="pdqTransactionId"
          :payment-method="paymentMethod"
        />
      </v-form>
    </validation-observer>
  </div>
</template>

<script>
import PlaceOrderButton from "@/views/checkout/CashPlaceOrderButton";
import { required, max, min } from "vee-validate/dist/rules";
import { extend, ValidationObserver, setInteractionMode } from "vee-validate";
import i18n from "@/i18n";
import DeliveryOptions from "@/views/checkout/print/DeliveryOptions";
import gql from "graphql-tag";
import AdminOrder from "@/views/checkout/AdminOrder";
import EkitabuTextInput from "@/components/EkitabuTextInput.vue";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: i18n.t("errors.required", { field: "{_field_}" }),
});

extend("max", {
  ...max,
  message: i18n.t("errors.maxLength", {
    field: "{_field_}",
    length: "{length}",
  }),
});

extend("min", {
  ...min,
  message: i18n.t("errors.minLength", {
    field: "{_field_}",
    length: "{length}",
  }),
});

export default {
  name: "CashScreen",
  components: {
    PlaceOrderButton,
    ValidationObserver,
    DeliveryOptions,
    AdminOrder,
    EkitabuTextInput,
  },
  props: {
    isPrintOrder: {
      type: Boolean,
      default: false,
    },
    containerClasses: {
      type: String,
      default: "mt-3",
    },
    paymentMethod: {
      type: String,
      default: "cash",
    },
  },
  data() {
    return {
      valid: false,
      shippingInfo: {
        altPhoneNumber: null,
        addressDetails: null,
        placeId: null,
        eventId: null,
      },
      schoolInfo: {
        schoolId: null,
        studentName: null,
        studentClass: null,
      },
      isPickupOrder: false,
      deliveryOptionsValid: this.isPrintOrder ? false : true,
      adminOrderDetails: {
        forEmail: null,
        forName: null,
        phoneNumber: null,
        event: null,
      },
      pdqTransactionId: null,
    };
  },
  apollo: {
    getWebServiceUser: {
      query: gql`
        query getUserInfo {
          getWebServiceUser {
            id
            email
            familyName
            givenName
            phoneNumber
            emailVerified
            alternativePhoneNumber
          }
        }
      `,
    },
  },
  methods: {
    setShippingInfo(shippingInfo) {
      this.shippingInfo = shippingInfo;
    },
    setSchoolInfo(schoolInfo) {
      this.schoolInfo = schoolInfo;
    },
    setIsPickupOrder(isPickupOrder) {
      this.isPickupOrder = isPickupOrder;
    },
    setDeliveryOptionsValid(isValid) {
      this.deliveryOptionsValid = isValid;
    },
    setAdminOrderDetails(adminOrderDetails) {
      this.adminOrderDetails = adminOrderDetails;
    },
  },
};
</script>
